import react from "react";
import "./Carregando.css";

const Carregando = () => {
    return (
        <div id="objCarregaTela" className="carregando">
            <div className="loader"></div>
            {/* <h1>Carregando...</h1>
            <img src="/imagens/carregando.gif" alt="Carregando..." /> */}
        </div>
    );
}
export default Carregando;
